import React from "react";
import logoUrl from "../../assets/branding/dva_logo.png";

export default function HeaderLogo() {
  return (
    <img
      src={logoUrl}
      alt="Data Value Suite"
      className="h-8 w-auto select-none"
      draggable={false}
    />
  );
}